import './Start_tour.css';
import { Link } from 'react-router-dom';

function Start_tour() {
    return (
        <>
            <div className="start">
                <h1>Готовы начать виртуальную экскурсию?</h1>
                <p>Познакомьтесь с нашей школой прямо сейчас, не выходя из дома</p>
                <Link to="/Choose_floor" className="btn_btn">Начать экскурсию ▶</Link>
            </div>
        </>
    );
}

export default Start_tour;